import React from "react";
import LeftNavigation from "@acl-services/sriracha-left-navigation";

const LeftNavPanel = props => <LeftNavigation {...props} />;

export default LeftNavPanel;
